import {
  KeyReferenceBar,
  KeyReferenceBarSection,
} from '@apex/component-library'
import { Box, Stack } from '@chakra-ui/react'
import React from 'react'
import { FaExternalLinkAlt } from 'react-icons/fa'
import { ContextualLink } from '../../../ContextualLink'
import { PermissionsEnum } from '../../../../constants'
import { usePermissions } from '../../../../hooks'
import {
  capitalizeWord,
  formatPhoneNumber,
  getAppConfigSetting,
} from '../../../../utils'
import { AccountDetails } from '../../../../types'

interface InitiateTransferKeyReferenceBarComponentProps {
  accountDetails: AccountDetails
}

const InitiateTransferKeyReferenceBarComponent = ({
  accountDetails,
}: InitiateTransferKeyReferenceBarComponentProps) => {
  const { hasPermission } = usePermissions()
  const canNavigateToAccount = hasPermission(PermissionsEnum.AccountRead)

  const {
    accountNumber,
    accountTitle,
    accountNames,
    accountAddress,
    phoneNumbers,
    repCode,
    taxId,
    accountType,
    accountRegistration,
  } = accountDetails

  const formattedAddressLine1 = `${
    accountAddress?.streetAddress?.join(' ') || ''
  }`
  const formattedAddressLine2 = `${accountAddress?.city || ''}, ${
    accountAddress?.state || ''
  } ${accountAddress?.postalCode || ''} ${accountAddress?.country || ''}`
  const formattedPhoneNumbers = phoneNumbers?.map(num => (
    <Box key={num.phoneNumber}>{`${capitalizeWord(
      num.phoneNumberType
    )}: ${formatPhoneNumber(num.phoneNumber)} ${num.extension || ''}`}</Box>
  ))
  const formattedAccountRegistration = `${
    accountRegistration?.split('_').join(' ') || ''
  }`

  return (
    <KeyReferenceBar margin="0 -1rem">
      <KeyReferenceBarSection title="Account Number">
        {accountNumber &&
          (canNavigateToAccount ? (
            <ContextualLink
              href={`${getAppConfigSetting(
                'appsUrl'
              )}/accounts/#/${accountNumber}?skipSearch=true`}
              icon={FaExternalLinkAlt}
              isExternal
            >
              {accountNumber}
            </ContextualLink>
          ) : (
            `${accountNumber}`
          ))}
      </KeyReferenceBarSection>
      <KeyReferenceBarSection title="Title">
        {accountTitle}
      </KeyReferenceBarSection>
      <KeyReferenceBarSection title="Name and Address">
        <Stack direction="column" spacing={0}>
          <Box>{(accountNames?.length && accountNames.join(', ')) || ''}</Box>
          <Box>{formattedAddressLine1}</Box>
          <Box>{formattedAddressLine2}</Box>
        </Stack>
      </KeyReferenceBarSection>
      <KeyReferenceBarSection title="Phone Numbers">
        <Stack direction="column" spacing={0}>
          {formattedPhoneNumbers}
        </Stack>
      </KeyReferenceBarSection>
      <KeyReferenceBarSection title="Rep Code">
        {repCode}
      </KeyReferenceBarSection>
      <KeyReferenceBarSection title="Tax ID">{taxId}</KeyReferenceBarSection>
      <KeyReferenceBarSection title="Type">
        {accountType}
      </KeyReferenceBarSection>
      <KeyReferenceBarSection title="Account Registration">
        {formattedAccountRegistration}
      </KeyReferenceBarSection>
    </KeyReferenceBar>
  )
}

export default InitiateTransferKeyReferenceBarComponent
